export default defineNuxtPlugin((NuxtApp) => {
  NuxtApp.vueApp.component("NuxtLink", defineNuxtLink({}));
});
